<!--
오류설정 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <!-- stepper -->
            <div class="uk-modal-header p-0d5rem">
                <div class="stepper">
                    <div
                        class="step"
                        :class="step1Class"
                    >
                        <div class="circle">1</div>
                        <div class="label">오류정보 입력</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step2Class"
                    >
                        <div class="circle">2</div>
                        <div class="label">이미지 업로드</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step3Class"
                    >
                        <div class="circle">3</div>
                        <div class="label">보관장소</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step4Class"
                    >
                        <div class="circle">4</div>
                        <div class="label">라벨출력</div>
                    </div>
                </div>
            </div>


            <div class="uk-modal-body pt-1 pb-0d5rem pl-1rem pr-1rem">
                <!-- 오류정보 입력 -->
                <div v-show="currStep === 1">
                    <app-error-type
                        class="mb-0d5rem"
                        name="type"
                        :init-value="inputs.type"
                        @change="val => inputs.type = val"
                    ></app-error-type>

                    <!-- 실제도착수량 -->
                    <div
                        class="uk-flex uk-flex-left mb-0d5rem"
                        v-show="inputs.type === 22"
                    >
                        <div class="bg-stone-800 text-white ml-0d25rem p-0d25rem w-8rem uk-text-center font-bold">실제도착수량</div>
                        <app-input-text

                            class=""
                            type="text"
                            input-size=""

                            name="arrival_amount"
                            v-model="inputs.arrival_amount"

                            placeholder="실제 도착한 수량을 정확히 입력하세요"
                        > </app-input-text>
                    </div>

                    <!-- 유통기한 -->
                    <div
                        class="uk-flex uk-flex-left mb-0d5rem"
                        v-show="inputs.type === 14"
                    >
                        <div class="bg-stone-800 text-white ml-0d25rem p-0d25rem w-8rem uk-text-center font-bold">유통기한</div>
                        <app-input-text

                            class=""
                            type="text"
                            input-size=""

                            name="expiration_date"
                            v-model="inputs.expiration_date"

                            placeholder="날짜입력"
                        > </app-input-text>

                        <div class="ml-1rem bg-yellow-100 p-0d5rem border border-gray">건강식품/식품, 동물영양제인 경우만 입력해 주세요</div>
                    </div>

                    <div class="uk-flex uk-flex-between">
                        <!-- 오류 상세 -->
                        <div class="p-0d25rem border border-sky-700">
                            <div class="uk-flex uk-flex-bottom">
                                <div class="font-size-1rem font-bold text-white bg-sky-700 p-0d5rem">오류상세</div>
                                <div class="ml-1rem font-size-0d875rem">
                                    오류내용을 구체적으로 작성하세요.<br />
                                    오류내용이 2가지 이상인 경우, 나머지 오류 내용에 대해서 설명해 주세요.
                                </div>
                            </div>

                            <app-input-textarea
                                ref="memo"
                                type="textarea"
                                input-size=""
                                :textarea-rows="3"

                                name="memo"
                                v-model="inputs.memo"

                                :placeholder="memoPlaceholder"
                            >

                            </app-input-textarea>
                        </div>

                        <div class="uk-width-expand ml-1rem">
                            <!-- 리턴라벨 -->
                            <app-error-return-label
                                class="mb-0d5rem"
                                name="return_label"
                                :init-value="inputs.return_label"
                                @change="val => inputs.return_label = val"
                            ></app-error-return-label>


                            <!--- 버튼 -->
                            <div class="uk-flex">
                                <button
                                    type="button"
                                    class="uk-button uk-button-default cancel-button uk-modal-close mr-0d5rem"
                                >
                                    <span uk-icon="icon: close"></span> 취소
                                </button>
                                <button
                                    type="button"
                                    class="uk-button uk-button-danger done-button uk-width-expand"
                                    v-on:click="submit()"
                                >
                                    <span uk-icon="icon: check"></span>
                                    완료(오류설정)
                                </button>
                            </div>
                        </div>

                    </div>







                </div>

                <!-- 이미지 업로드 -->
                <div v-if="currStep === 2">
                    <div class="uk-text-center uk-padding-small uk-text-medium3">
                        오류 이미지를 촬영하세요<br />
                        <span class="uk-text-muted">CLICK [PHONE] BUTTON</span>
                    </div>

                    <!-- 업로드 모듈 -->
                    <app-file-uploader
                        class="uk-margin-bottom"
                        :csrf-token="csrfToken"
                        :type="1"
                        :cm-id="cmId"
                        :session-owner="sessionOwner"
                        header-text="오류 이미지"
                        size=""
                    ></app-file-uploader>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            v-on:click="doneStep2"
                        >
                            <span uk-icon="icon: check"></span>
                            완료(이미지 업로드)
                        </button>
                    </div>
                </div>

                <!-- 보관장소 -->
                <div v-if="currStep === 3">

                    <app-input-ex
                        class="uk-margin-bottom"
                        type="text"
                        input-size=""

                        name="memo"
                        v-model="storage"
                        label="보관장소"

                        required-layout="label-left"

                        placeholder="실제 보관장소를 입력하세요"
                    > </app-input-ex>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large uk-margin-right"
                            v-on:click="currStep = 2"
                        >
                            <i class="material-icons">keyboard_arrow_left</i>
                            뒤로
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            v-on:click="doneStep3"
                        >
                            <span uk-icon="icon: check"></span>
                            보관장소 입력
                        </button>
                    </div>
                </div>

                <!-- 라벨출력 -->
                <div v-if="currStep === 4">
                    <div class="uk-text-center uk-text-medium3 uk-margin-bottom">
                        보관라벨 출력 후 해당 장소에 상품을 갖다놓으세요
                    </div>

                    <div class="uk-text-center uk-margin-bottom uk-text-primary uk-text-large">
                        {{ storage }}
                    </div>

                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            onclick="$.app.print.store_label(arguments);"
                            :data-prod-id="prodId"
                            title="현재 상품의 보관라벨을 출력합니다"
                        >
                            <i class="material-icons" >print</i>
                            <span class="text">PRINT STORE-LABEL (보관라벨)</span>
                        </button>
                    </div>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large uk-margin-right"
                            v-on:click="currStep = 3"
                        >
                            <i class="material-icons" style="font-size: 30px; vertical-align: middle">keyboard_arrow_left</i>
                            뒤로 (보관장소 수정)
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large uk-modal-close"
                        >
                            <span uk-icon="icon: check"></span>
                            완료
                        </button>
                    </div>
                </div>


            </div>



        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,

            /**
             * 촬영세션 용 현재 사용자 ID
             */
            sessionOwner: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    type: null,
                    return_label: null,
                    memo: null,
                    arrival_amount: null,
                    expiration_date: null,
                },

                /**
                 * 보관장소
                 */
                storage: null,

                /**
                 * (int) 진행단계
                 *       1~3
                 **/
                currStep: 1,

                // 커뮤니케이션 ID
                cmId: null,

                // (bool) 모달창 종료이벤트 등록된적있는지 플래그값, 창 여러번 켜고 닫을때, 이벤트 한번만 등록되기 위함
                hasModalCloseEvent: false,
            };
        },
        computed: {
            /**
             * 오류상세내용 textarea placeholder 내용
             * @return string
             */
            memoPlaceholder() {
                let placeholder = null;

                switch (this.inputs.type) {
                    case 1:
                    case 4:
                        placeholder = '오류내용을 구체적으로 작성 (예시: 발등에 눈에 띄는 스크래치 있음)';
                        break;
                    case 11:
                        placeholder = '도착한 상품 설명 (예시: 신발 도착)';
                        break;
                    case 12:
                        placeholder = '도착한 색상 설명 (예시: 블랙 도착)';
                        break;
                    case 13:
                        placeholder = '도착한 사이즈 설명 (예시: 8사이즈 도착 or W8 도착)';
                        break;
                    default:
                        placeholder = '오류내용 작성';
                }

                return placeholder;
            },

            // 스텝1 클래스계산
            step1Class: function () {
                let step = 1;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝2 클래스계산
            step2Class: function () {
                let step = 2;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝3 클래스계산
            step3Class: function () {
                let step = 3;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝4 클래스계산
            step4Class: function () {
                let step = 4;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();


                // 모달창 종료이벤트
                if (! this.hasModalCloseEvent) {
                    UIkit.util.on(this.$el, 'beforehide', () => {
                        //console.log('before');
                        this.close();

                    });

                    this.hasModalCloseEvent = true;
                }

            },

            /**
             * 폼
             */
            form() {
                // 입력값 초기화
                this.inputs.type = null;
                this.inputs.arrival_amount = null;
                this.inputs.memo = null;
                this.inputs.expiration_date = null;
                this.inputs.return_label = null;


                // 폼띄우기
                this.displayForm();
            },




            /**
             * submit
             */
            submit() {
                // 오류종류
                if (this.inputs.type === null) {
                    alert('오류종류를 선택하세요');
                    return;
                }

                // 실제도착수량 입력검증
                if (this.inputs.type === 22) {
                    let amount = Number(this.inputs.arrival_amount);
                    if (isNaN(amount) || amount < 1) {
                        alert('실제도착수량을 반드시 입력하세요');
                        return;
                    }
                }

                // 유통기한 입력검증
                if (this.inputs.type === 14) {
                    if (_.trim(this.inputs.expiration_date) === '') {
                        alert('유통기한을 반드시 입력하세요');
                        return;
                    }
                }

                // 리턴라벨
                if (this.inputs.return_label === null) {
                    alert('리턴라벨 보관여부를 선택하세요');
                    return;
                }



                // 오류상세내용 입력검증
                if ((this.inputs.type === 11 || this.inputs.type === 12 || this.inputs.type === 13)
                    && _.trim(this.inputs.memo) === ''
                ) {
                    alert('오류상세내용을 반드시 입력하세요');
                    this.$refs['memo'].inputFocus();
                    return;
                }

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/prods/' + this.prodId + '/errors',
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        // 스텝 변경
                        this.currStep = 2;

                        // 리소스ID 저장
                        this.cmId = response.cm_id;
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },

            /**
             * step2 완료처리
             */
            doneStep2() {


                /**
                 * 보관장소 조회
                 */
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // todo : 시간없어서 보관장소 1개 정보가 아닌 모든 상품정보 가져옴. 나중에 보관장소만 가져오게 리팩토링 필요함

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + this.prodId,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.storage = response.prod.storage;

                    if (
                        this.storage // 보관장소가 발급되었으면, 입력단계 건너뜀
                        || this.inputs.type == 21 // 미도착이어도 건너뜀
                    ) {
                        this.currStep = 4;
                    } else {
                        this.currStep = 3;
                    }

                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },

            /**
             * step3 완료처리
             */
            doneStep3() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prodId + '/storage',
                        data: {
                            '_token': this.csrfToken,
                            'storage': this.storage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.currStep = 4;
                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },

            /**
             * 작업완료 (창 닫기했을때 실행되는 액션)
             */
            close() {
                // 첫번째 단계가 지났으면, 에러등록이완료되었으므로, 완료이벤트 발생
                if (this.currStep > 1) {
                    // 완료 이벤트 발생
                    this.$emit('done', null);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /*
    stepper css
    https://codepen.io/shanejdonnelly/pen/wJqgQR?page=3
    */
    .stepper{
        font-size: 1.125rem;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .step{
        margin: 0 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .divider{ background-color: #cfcfcf; height: 1px; width: 3rem}

    .circle{
        background: #cfcfcf;
        border-radius: 50%;
        color: #ffffff;
        width: 1.5rem;
        height: 1.5rem;
        line-height: 1.5rem;
        text-align: center;

    }

    .label{ color: #cfcfcf; line-height: 24px; margin-left: 8px; }

    .active{
        .circle{ background: #0f7ae5; }
        .label{ color: #0f7ae5; font-weight: 400; }
    }

    .complete{
        .circle{
            background: #666;
        }
        .label{
            color: #666;
            text-decoration-line: line-through;
        }
    }

    .cancel-button-button {

    }
    .done-button {

    }
</style>